import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class MembersNonMembersInformation extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-venue-info-landing-page-singlesite',
			sectionWrapperSelector: '.p-venue-info-landing-page-singlesite-wrapper',
			modalSelector: '#js-individual-venue-members-non-members-form-modal',
			triggerSelectors: [
				'.js-individual-venue-add-members-non-members',
				'.js-individual-venue-edit-members-non-members'
			],
			stepsEndpointAttr: 'members-non-members-steps-endpoint',
			submitEndpointAttr: 'members-non-members-submit-endpoint',
			logPrefix: 'MembersNonMembersInformation'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: true,
			isBackButtonEnabled: true,
			radioAnswerField: 'id',
			isRenderDependentQuestion: true,
			conditionalStepsVisiblity: true,
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			nextStepButtonLabel: 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue'
			}
		};
	}
}

VenueRegistrationFormModal.boot(MembersNonMembersInformation);

export default MembersNonMembersInformation;
